import { useNavigate } from 'react-router-dom';

import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import { NewsCard } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCard';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { type RelatedNewsNormalized } from 'hb-react/shared/apps/News/types';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import {
  Col,
  getBpNum,
  Row,
} from 'hb-react/shared/components/DesignSystem/Grid';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

interface NewsRelatedRowProps {
  relatedNews: Array<RelatedNewsNormalized>;
}

const NewsRelatedRow = ({ relatedNews }: NewsRelatedRowProps) => {
  const isMobile = useMatchBreakpoint('s');
  const navigate = useNavigate();
  const topicContext = useTopicContext();
  const handleOnClick = (id: number | string) => {
    if (topicContext?.topicId) {
      const route = dynamicTopicResourcePath(
        Routes.topic_new_path(topicContext.topicId, id),
        topicContext,
      );

      return navigate(route);
    }

    return navigate(Routes.new_json_path(id));
  };

  return (
    <Row>
      {relatedNews.map((letter, index) => {
        const { content, coverPicture, id, publishedAt, subject } = letter;

        if (!id) {
          return null;
        }

        const date = dayjs(publishedAt).format('LL');

        return (
          <Col
            width={({ numCols }) => ({
              xl: 4 / getBpNum(numCols, 'xl'),
              m: 5 / getBpNum(numCols, 'm'),
            })}
            offset={
              index === 0
                ? ({ numCols }) => ({
                    xl: 2 / getBpNum(numCols, 'xl'),
                    m: 1 / getBpNum(numCols, 'm'),
                  })
                : undefined
            }
            key={id}
          >
            <NewsCard
              coverPicture={
                isMobile
                  ? coverPicture?.previewUrl || ''
                  : coverPicture?.mediumUrl || ''
              }
              publishedAt={date}
              subject={subject}
              description={content}
              onClick={() => handleOnClick(id)}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default NewsRelatedRow;
